import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider';
import { workspaceHomePath } from '../../auth/workspaces';
import { UmbLogo } from '../../components/layout/UmbLogo';

export function EntraCallbackPage() {
  const navigate = useNavigate();
  const { completeMicrosoftSignIn, selectOrganization, setAuthError } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const result = await completeMicrosoftSignIn();
        if (!active) return;
        const memberships = result.memberships || [];
        if (memberships.length === 1) {
          const next = await selectOrganization(memberships[0].organization_id);
          if (active) {
            navigate(workspaceHomePath(next.workspaceId), { replace: true });
          }
          return;
        }
        if (memberships.length === 0) {
          setError(
            'This Microsoft account has no eVault workspace for the role you selected.'
          );
          return;
        }
        navigate('/select-workspace', { replace: true });
      } catch (err) {
        if (!active) return;
        const message = err.message || 'Microsoft sign-in failed';
        setError(message);
        setAuthError(message);
      }
    })();
    return () => {
      active = false;
    };
  }, [completeMicrosoftSignIn, selectOrganization, navigate, setAuthError]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-eorig-surface px-4 py-10 font-sans text-eorig-ink">
      <div className="w-full max-w-md">
        <div className="rounded-2xl border border-eorig-border bg-white p-6 shadow-eorig-card sm:p-8">
          <UmbLogo />
          <h1 className="mt-6 text-2xl font-semibold tracking-normal text-eorig-ink">
            Completing Microsoft sign-in
          </h1>
          {error ? (
            <>
              <p className="mt-4 text-sm text-red-600" role="alert">
                {error}
              </p>
              <Link
                to="/signin/email"
                className="mt-6 inline-flex text-sm font-medium text-eorig-cyan underline"
              >
                Sign in with email instead
              </Link>
            </>
          ) : (
            <p className="mt-4 text-sm text-eorig-muted">
              Verifying your Microsoft account and opening eVault…
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
